/************* fronto-bin-calc.js *************/

import * as Fronto from "./utility.js";
import './default.js';

// wrapper
function frontoBinCalc(enc, encoding, datatype) {
  if (encoding?.[enc]?.bin !== undefined && encoding?.[enc]?.bin !== false) {
    let bin_obj = {};
    if (encoding[enc].bin.constructor.name == "Object") {
      bin_obj = Fronto.deepcopy(encoding[enc].bin)
    }
    bin_obj.field = encoding[enc].field;
    // extent
    if (datatype[encoding[enc].field].type === "temporal") {
      bin_obj.extent = [Date.parse(datatype[encoding[enc].field].min), Date.parse(datatype[encoding[enc].field].max)];
    } else {
      bin_obj.extent = [datatype[encoding[enc].field].min, datatype[encoding[enc].field].max];
    }
    return bin_calc(bin_obj);
  } else {
    return null;
  }
}
// below Modified https://github.com/vega/vega/blob/master/packages/vega-statistics/src/bin.js
function bin_calc(_) {
  // determine range
  const maxb = _.maxbins || 20,
    base = _.base || 10,
    logb = Math.log(base),
    div = _.divide || [5, 2];

  let min = _.extent[0],
    max = _.extent[1],
    step, level, minstep, v, i, n;

  const span = _.span || (max - min) || Math.abs(min) || 1;

  if (_.step) {
    // if step size is explicitly given, use that
    step = _.step;
  } else if (_.steps) {
    // if provided, limit choice to acceptable step sizes
    v = span / maxb;
    for (i = 0, n = _.steps.length; i < n && _.steps[i] < v; ++i);
    step = _.steps[Math.max(0, i - 1)];
  } else {
    // else use span to determine step size
    level = Math.ceil(Math.log(maxb) / logb);
    minstep = _.minstep || 0;
    step = Math.max(
      minstep,
      Math.pow(base, Math.round(Math.log(span) / logb) - level)
    );

    // increase step size if too many bins
    while (Math.ceil(span / step) > maxb) { step *= base; }

    // decrease step size if allowed
    for (i = 0, n = div.length; i < n; ++i) {
      v = step / div[i];
      if (v >= minstep && span / v <= maxb) step = v;
    }
  }

  // update precision, min and max
  v = Math.log(step);
  const precision = v >= 0 ? 0 : ~~(-v / logb) + 1,
    eps = Math.pow(base, -precision - 1);
  if (_.nice || _.nice === undefined) {
    v = Math.floor(min / step + eps) * step;
    min = min < v ? v - step : v;
    max = Math.ceil(max / step) * step;
  }

  return {
    field: _.field,
    start: min,
    stop: max === min ? min + step : max,
    step: step
  };
}

export { frontoBinCalc };